//@ts-check
import React, { useState, useEffect, useContext } from "react";
import LoginAnnouncement from "../HomePage/LoginAnnounce";
// import "../Css/Login.css";
import { LoginContext } from "../Basic/BasicData";
import LoginPanel from "./LoginPanel";
import Register from "./Register/Register";
import ConfirmPersonalInformation from "./Register/ConfirmPersonalInformation";
import { Button } from "@progress/kendo-react-buttons";
import { Slide } from "@progress/kendo-react-animation";
import ForgotPW from "./ForgotPw/ForgotPW";
import Foot from "./Foot";

const Login = (props) => {
  const [pageState, setPageState] = useState(0);
  // 0: 登入, 1: 個資聲明, 2: 註冊, 3: 忘記密碼

  const {loginStatus, setLoginStatus} = useContext(LoginContext);

  // 每次切換到登入頁面時，重置聲明確認和忘記密碼的狀態
  useEffect(() => {
    if (pageState === 0) {
      setPageState(0);
    }
  }, [pageState]);

  useEffect(() => {
    
    if(loginStatus !== null)
      setPageState(loginStatus)

    //清除lognStatus狀態,讓之後可以重新使用副作用
    setLoginStatus(null)
  }, [loginStatus]);

  return (
    <div >
      <div className="login_bg">
        <div className="flex middle_block">
          <LoginAnnouncement />
          {/* 登入畫面 */}
          {pageState === 0 && (
            <LoginPanel {...props}
              goConfirmPersonalInformation={() => setPageState(1)} // 切換到個資聲明畫面
              goforgotPW={() => setPageState(3)} // 切換到忘記密碼畫面
            />
          )}
          {/* 個資聲明畫面 */}
          {pageState === 1 && (
            <ConfirmPersonalInformation
              returnLogin={() => setPageState(0)} // 切換回登入畫面
              goRegister={() => setPageState(2)} // 確認後切換到註冊畫面
            />
          )}
          {/* 註冊畫面 */}
          {pageState === 2 && (
            <Register returnLogin={() => setPageState(0)} /> // 切換回登入畫面
          )}
          {/* 忘記密碼畫面 */}
          {pageState === 3 && (
            <ForgotPW returnLogin={() => setPageState(0)} /> // 切換回登入畫面
          )}
          {/* 驗證信寄送成功畫面 */}
          {/* {pageState === 4 && (
            <sendMailSucess returnLogin={() => setPageState(0)} /> // 切換回登入畫面
          )} */}
        </div>
        {/* 登入頁的Foot顯示邏輯與登入後的不一樣，這邊直接再注入一次Foot Component */}
        <Foot />
      </div>
    </div>
  );
};

export default Login;
